import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Tool from '../tool';
import { pluckNumber } from '../../../lib';
import { getDep } from '../../../dependency-manager';
var R = getDep('redraphael', 'plugin'),
    M = 'M',
    m = 'm',
    v = 'v',
    COLOR_5F5F5F = '5F5F5F';

var ScrollAnchor =
/*#__PURE__*/
function (_Tool) {
  _inherits(ScrollAnchor, _Tool);

  function ScrollAnchor() {
    var _this;

    _classCallCheck(this, ScrollAnchor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollAnchor).call(this)), _this._evtHandlers = {};
    return _this;
  }

  _createClass(ScrollAnchor, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = this.config,
          d = b.getLinkedParent().config;
      c.fillColor = a.anchorFill || d.displayFlat && R.tintshade(d.color, -.6).rgba || [270 * d.isHorizontal, R.tintshade(d.color, .3).rgba + ':40', R.tintshade(d.color, -.7).rgba].join('-'), c.strokeColor = a.anchorStroke || R.tintshade(d.color, -.6).rgba, c.drawStripes = pluckNumber(a.drawStripes, 0), c.stripesStroke = a.stripesStroke || COLOR_5F5F5F, c._nodeDimensions = {};
    }
  }, {
    key: "attachEventHandlers",
    value: function attachEventHandlers() {
      var a,
          b,
          c,
          d = this,
          e = d.config,
          f = this.getLinkedParent(),
          g = f.config,
          h = g.isHorizontal;
      d.addEventListener('fc-dragmove', d._evtHandlers.dragmove || (d._evtHandlers.dragmove = function (f) {
        c = a + f.originalEvent.data[b] / e.trackLength, 1 <= c ? c = 1 : (0 >= c || isNaN(c)) && (c = 0), g.scrollPosition = c, d.asyncDraw(), 'function' == typeof g.evt.scroll && g.evt.scroll(g.scrollPosition);
      })), d.addEventListener('fc-dragstart', d._evtHandlers.dragstart || (d._evtHandlers.dragstart = function () {
        b = h ? 0 : 1, a = g.scrollPosition, 'function' == typeof g.evt.scrollStart && g.evt.scrollStart(g.scrollPosition);
      })), d.addEventListener('fc-dragend', d._evtHandlers.dragend || (d._evtHandlers.dragend = function () {
        'function' == typeof g.evt.scrollEnd && g.evt.scrollEnd(g.scrollPosition);
      }));
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = Math.min;
      var b,
          c,
          d = this,
          e = d.config,
          f = this.getLinkedParent(),
          g = f.config,
          h = g.x + .5,
          i = g.y + g.padding + .5,
          j = g.width - 1,
          k = 1 > g.height - 1 ? 1 : g.height - 1,
          l = g.restrictScrollAnchor ? Math.max(g.scrollRatio, .01) : g.scrollRatio,
          n = g.isHorizontal,
          o = pluckNumber(g.scrollPosition, g.startPercent, 0),
          p = 0,
          q = n ? j * l : k * l;
      1 <= o ? o = 1 : (0 >= o || isNaN(o)) && (o = 0), g.showButtons && (p = n ? a(k, .5 * j) : a(j, .5 * k), q -= 2 * p * l), e.trackLength = b = n ? j - 2 * p - q : k - 2 * p - q, e.trackOffset = c = n ? h + p + .5 : i + p + .5, e._nodeDimensions = {
        x: n ? c + b * o : h,
        y: n ? i : c + b * o,
        width: n ? 1 > q - 1 ? 1 : q - 1 : 1 > j ? 1 : j,
        height: n ? 1 > k ? 1 : k : 1 > q - 1 ? 1 : q - 1
      }, d.addGraphicalElement({
        el: 'rect',
        attr: {
          x: e._nodeDimensions.x,
          y: e._nodeDimensions.y,
          width: e._nodeDimensions.width,
          height: e._nodeDimensions.height,
          fill: e.fillColor,
          stroke: e.strokeColor,
          r: g.roundEdges && 2 || 0
        },
        container: {
          id: 'scrollerGroup',
          label: 'scrollerGroup',
          isParent: !0
        },
        component: d,
        label: 'scrollerAnchor',
        id: 'scrollerAnchor'
      }), e.drawStripes && 8 <= e._nodeDimensions.width && d.addGraphicalElement({
        el: 'path',
        attr: {
          path: [M, e._nodeDimensions.x + e._nodeDimensions.width / 2 - 3, e._nodeDimensions.y + .2 * e._nodeDimensions.height, v, .6 * e._nodeDimensions.height, m, 3, -.6 * e._nodeDimensions.height, v, .6 * e._nodeDimensions.height, m, 3, -.6 * e._nodeDimensions.height, v, .6 * e._nodeDimensions.height],
          stroke: e.stripesStroke,
          "stroke-linecap": 'round',
          "stroke-width": 2
        },
        container: {
          id: 'scrollerGroup',
          label: 'scrollerGroup',
          isParent: !0
        },
        component: d,
        label: 'scrollerAnchorStripe',
        id: 'scrollerAnchorStripe'
      });
    }
  }]);

  return ScrollAnchor;
}(Tool);

export default ScrollAnchor;